// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"b8d9376a0dc9e93d1484","453":"b3dbbe9715a0dff2df42","454":"be469ec0a02687c54b86"}[chunkId] + ".js";
};